var $ = require('./../sw-jquery');
var YoutubePlayer = require('./../../lib/views/YoutubePlayer');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-youtube-player]').each(function() {
    var $el = $(this);
    var videoId = $el.data('swYoutubePlayer');

    new YoutubePlayer({
      el: $el,
      videoId: videoId
    });

  });


};
